import React from 'react';
// Components
import ManageDesigns from 'components/common/ManageDesigns';

const ManageAthleteDesigns = (): JSX.Element => {
  return <ManageDesigns />;
};

export default ManageAthleteDesigns;
